import { FunctionComponent } from "react";
import CustomModal from "../../CustomModal";
import Row from "../../../Row";
import Text from "../../../Text";
import Column from "../../../Column";
import SvgFragment from "../../../../fragments/SvgFragment";
import { styles } from "../../../../styles/themes/style";
import { IEnrichedTransaction } from "./CalculateEnrichmentModal";

interface IEnrichmentCompleteModalProps {
  enrichedTransaction: IEnrichedTransaction;
  onClose: () => void;
}

const EnrichmentCompleteModal: FunctionComponent<
  IEnrichmentCompleteModalProps
> = ({ enrichedTransaction, onClose }) => {
  return (
    <CustomModal headingText={"Enrichment complete! 🎉"} closeButton>
      <Row
        gap="10px"
        style={{
          width: "100%",
        }}
      >
        <Column gap="16px" style={{ width: "100%" }}>
          <Row gap="4px" alignItems spaceBetween>
            <Text>Overview</Text>
            <Row gap="16px" alignItems>
              <Row
                style={{
                  width: "58px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <SvgFragment type="checkGreen" />
              </Row>
              <Row
                style={{
                  width: "58px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <SvgFragment type="errorLight" />
              </Row>
            </Row>
          </Row>
          <Row
            style={{
              width: "100%",
              height: "1px",
              backgroundColor: styles.colors.black200,
            }}
          />
          <Column gap="8px" justifyCenter>
            <Row gap="4px" alignItems spaceBetween>
              <Text>{"Business emails"}</Text>
              <Row gap="16px" alignItems>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "4px",
                  }}
                >
                  <Text>
                    {enrichedTransaction?.businessEmailsCountAfterEnrichment ||
                      0}
                  </Text>
                </Row>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "8px",
                  }}
                >
                  <Text>
                  {(enrichedTransaction?.businessEmailsCount || 0) -
                    (enrichedTransaction?.businessEmailsCountAfterEnrichment ||
                      0)}
                  </Text>
                </Row>
              </Row>
            </Row>
            <Row gap="4px" alignItems spaceBetween>
              <Text>{"Personal emails"}</Text>
              <Row gap="16px" alignItems>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "4px",
                  }}
                >
                  <Text>
                    {enrichedTransaction?.privateEmailsCountAfterEnrichment ||
                      0}
                  </Text>
                </Row>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "8px",
                  }}
                >
                  <Text>
                  {(enrichedTransaction?.privateEmailsCount || 0) -
                    (enrichedTransaction?.privateEmailsCountAfterEnrichment ||
                      0)}
                  </Text>
                </Row>
              </Row>
            </Row>
            <Row gap="4px" alignItems spaceBetween>
              <Text>{"Phone numbers"}</Text>
              <Row gap="16px" alignItems>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "4px",
                  }}
                >
                  <Text>
                    {enrichedTransaction?.phonesCountAfterEnrichment || 0}
                  </Text>
                </Row>
                <Row
                  style={{
                    width: "58px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "8px",
                  }}
                >
                  <Text>
                  {(enrichedTransaction?.phonesCount || 0) -
                    (enrichedTransaction?.phonesCountAfterEnrichment || 0)}
                  </Text>
                </Row>
              </Row>
            </Row>
          </Column>
        </Column>
      </Row>
    </CustomModal>
  );
};

export default EnrichmentCompleteModal;
